var map = {
  "./ADMINISTRATIVO.svg": "230515",
  "./ANALISE.svg": "724110",
  "./APAC.svg": "844696",
  "./BUSCA_ATIVA.svg": "871173",
  "./CONECTA.svg": "148176",
  "./CONSOLE.svg": "447338",
  "./CONTRARREFERENCIA.svg": "523790",
  "./DRA.svg": "263846",
  "./EEG.svg": "968556",
  "./ELETROCARDIOGRAFIA.svg": "437976",
  "./ESPIROMETRIA.svg": "513233",
  "./ESTOMATO.svg": "469537",
  "./EXAMES.svg": "686250",
  "./GESTAOPACS.svg": "981529",
  "./HELPDESK.svg": "482341",
  "./MENSAGENS.svg": "752328",
  "./NEXUS.svg": "342796",
  "./OAUTH2.svg": "809994",
  "./OXIGENOTERAPIA.svg": "502290",
  "./PATOLOGIA.svg": "154407",
  "./POLISSONOGRAFIA.svg": "778091",
  "./RETINOGRAFIA.svg": "85668",
  "./RSE.svg": "262547",
  "./TELEATENDIMENTO.svg": "430387",
  "./TELECONSULTORIAS.svg": "657083",
  "./TELEDERMATO.svg": "849409",
  "./TELEEDUCACAO.svg": "758552",
  "./TFD.svg": "697183",
  "./TFDPASSAGENS.svg": "343980"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 565118;
